import { render, staticRenderFns } from "./ls-upload.vue?vue&type=template&id=3fed2871&scoped=true"
import script from "./ls-upload.vue?vue&type=script&lang=ts"
export * from "./ls-upload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fed2871",
  null
  
)

export default component.exports